<script setup lang="ts">
const appConfig = useAppConfig();
const title = `プライバシー・ポリシー | ${appConfig.SITE_NAME}`;
useHead({
  title,
  meta: [
    { name: "description", content: "プライバシー・ポリシー" },
    { name: "og:title", content: title },
    { name: "og:description", content: "プライバシー・ポリシー" },
    { name: "twitter:title", content: title },
    { name: "robots", content: "noindex" },
  ],
});
</script>

<template lang="pug">

v-container
  v-row(align="center" justify="center")
    v-col(cols="12").text-center
      h2 PRIVACY POLICY
  v-row(align="center" justify="center")
    v-col(cols="12").text-center
      h3 プライバシー・ポリシー
  v-row(no-gutters)
    v-col.pp-text
      h5 個人情報の利用目的
      p
        | 当サイトでは、メールでのお問い合わせ、会員登録などの際に、名前（ハンドルネーム）、
        | メールアドレス等の個人情報をご登録いただく場合がございます。
        | これらの個人情報は質問に対する回答や必要な情報を電子メールなどでご連絡する場合に利用させていただくものであり、
        | 個人情報をご提供いただく際の目的以外では利用
        | いたしません。

      h5 個人情報の第三者への開示
      p
        | 当サイトででは、個人情報は適切に管理し、以下に該当する場合を除いて第三者に開示することはありません。
        <br />
        |・本人のご了解がある場合
        <br />
        |・法令等への協力のため、開示が必要となる場合

      h5 個人情報の開示、訂正、追加、削除、利用停止
      p
        | ご本人からの個人データの開示、訂正、追加、削除、利用停止のご希望の場合には、ご本人であることを確認させていただいた上、速やかに対応させていただきます。

      h5 アクセス解析ツールについて
      p
        | 当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。
        <br />
        | このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。このトラフィックデータは匿名で収集されており、個人を特定するものではありません。
        | この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。

      h5 広告の配信について
      p
        | 当サイトは、Amazon、楽天を宣伝しリンクすることによってサイトが紹介料を獲得できる手段を提供することを目的に設定されたアフィリエイトプログラムの参加者です。
        | 第三者がコンテンツおよび宣伝を提供し、訪問者から直接情報を収集し、訪問者のブラウザにクッキーを設定したりこれを認識したりする場合があります。

      h5 免責事項
      p
        | 当サイトからリンクやバナーなどによって他のサイトに移動された場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。
        | 当サイトのコンテンツ・情報につきまして、可能な限り正確な情報を掲載するよう努めておりますが、誤情報が入り込んだり、情報が古くなっていることもございます。
        | 当サイトに掲載された内容によって生じた損害等の一切の責任を負いかねますのでご了承ください。

      h5 プライバシーポリシーの変更について
      p
        | 当サイトは、個人情報に関して適用される日本の法令を遵守するとともに、本ポリシーの内容を適宜見直しその改善に努めます。
        | 修正された最新のプライバシーポリシーは常に本ページにて開示されます。

</template>

<style lang="scss" scoped>
h2 {
  width: 100%;
  height: 52px;
  font-weight: 600;
  font-size: 34px;
  letter-spacing: 0.16px;
  background-color: #fff;
  color: #737373;
  margin: auto;
}

h3 {
  background-color: #f5f5f5;
  width: 315px;
  height: 47px;
  padding-top: 15px;
  color: #737373;
  font-size: 16px;
  letter-spacing: -0.56px;
  margin: auto;
  font-weight: 700;
}

h5 {
  font-size: 1.2rem;
}

.pp-text {
  width: 66.22%;
  height: auto;
  margin: 60px auto;
  font-family: a-otf-gothic-bbb-pr6n, sans-serif;
  font-size: 14px;
  letter-spacing: -0.56px;
  line-height: 32px;
  text-align: left;

  p {
    margin-bottom: 50px;
  }
}

@media (max-width: 576px) {
  .privay-policy {
    padding-top: 60px;
  }
}
</style>
